import { AvatarGroup, Box, Circle, type BoxProps, HStack, Stack, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface ChatItemProps extends BoxProps {
  title: string;
  avatars?: ReactNode;
  chatType: string;
  updatedAt: string;
  message: string;
  hasUnread?: boolean;
}

export function ChatItem({
  title,
  avatars,
  chatType,
  updatedAt,
  message,
  hasUnread,
  ...props
}: ChatItemProps) {
  return (
    <HStack
      align="flex-start"
      gap="3"
      px="4"
      py="3"
      _hover={{ bg: 'bg.subtle' }}
      cursor="pointer"
      {...props}
    >
      {avatars ? (
        <AvatarGroup size="sm" max={2}>
          {avatars}
        </AvatarGroup>
      ) : null}
      <Stack spacing="0" fontSize="sm" flex="1" isTruncated>
        <HStack spacing="1">
          <Text fontSize="sm" lineHeight="5" fontWeight="medium" flex="1">
            {title}
          </Text>
          {hasUnread === true ? <Circle size="0.5rem" bg="blue.500" /> : null}
          <Text color="fg.subtle" fontSize="xs">
            {updatedAt}
          </Text>
        </HStack>
        <Box color="fg.subtle">
          <Text fontSize="xs" lineHeight="5" fontWeight="medium">
            {chatType}
          </Text>
        </Box>
        <Box color="fg.muted" isTruncated>
          {message}
        </Box>
      </Stack>
    </HStack>
  );
}

export default ChatItem;
